module.exports = __webpack_public_path__ + "img/Facebook.9ad96d70.svg";